import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SettingComponent } from './setting.component';
import { UserSettingComponent } from './user-setting/user-setting.component';
import { SubscriptionSettingComponent } from './subscription-setting/subscription-setting.component';
import {SettingRoutingModule} from './setting-routing.module';
import {FormsModule} from '@angular/forms';
import {SubscriptionService} from './subscription.service';
import {ShareModule} from '../share/share.module';
import {NgbModalModule} from '@ng-bootstrap/ng-bootstrap';
import { SubscriptionItemPopupComponent } from './subscription-item-popup/subscription-item-popup.component';
import { SubscriptionItemListComponent } from './subscription-item-list/subscription-item-list.component';
import {BreadcrumbsComponent} from '../share/breadcrumbs/breadcrumbs.component';



@NgModule({
  declarations: [SettingComponent, UserSettingComponent, SubscriptionSettingComponent, SubscriptionItemPopupComponent, SubscriptionItemListComponent],
    imports: [
        CommonModule,
        ShareModule,
        SettingRoutingModule,
        FormsModule,
        NgbModalModule,
        BreadcrumbsComponent
    ],
  providers: [
    SubscriptionService
  ]
})
export class SettingModule { }
